module.exports = __webpack_public_path__ + "img/logo_easyparcel.43fc70bb.png";